import {useState} from "react";
import PropTypes from "prop-types";
import {TextField, Typography} from "@material-ui/core";

const LimitedCharactersInput = (props) => {
    const [remainingCharacters, setRemainingCharacters] = useState(props.characterLimit);
    const inputChanged = (event) => {
        if (event.target.value.length > props.characterLimit) {
            event.target.value = event.target.value.slice(0, props.characterLimit);
            setRemainingCharacters(0);
            return;
        }
        setRemainingCharacters(props.characterLimit - event.target.value.length);
        props.textChanged(event.target.value);
    };

    return (
        <>
            <TextField
                minRows={props.minRows}
                maxRows={props.maxRows}
                className="w-100 mb-8"
                onChange={inputChanged}
                onPaste={inputChanged}
                label={props.label}
                multiline
                variant="outlined"
            />
            {props.hideRemaningCharactersText !== true ? (
                <Typography className="display-block pl-4" variant="caption">
                    {`${remainingCharacters} caratteri rimanenti`}
                </Typography>
            ) : null}
        </>
    );
};

LimitedCharactersInput.defaultProps = {
    minRows: 8,
    maxRows: 8,
}

LimitedCharactersInput.propTypes = {
    hideRemaningCharactersText: PropTypes.bool,
    label: PropTypes.string,
    textChanged: PropTypes.func,
    maxRows: PropTypes.number,
    minRows: PropTypes.number,
};

export default LimitedCharactersInput;
